module.exports = __webpack_public_path__ + "img/title4.60e643de.png";